import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";
export const getReasonlist = async (type) => {
  try {
    return await getRequest(urls.GET_REASONLIST + `?type=${type}`);
  } catch (err) {
    return err;
  }
};
